import React, { createContext, FC, useCallback, useContext, useState } from 'react'
import { NavigationButton, NavigationLink } from './types'

type TopNavigationState = {
    links: NavigationLink[] | null
    buttons: NavigationButton[] | null
    setNavigation: (nav: { links: NavigationLink[] | null, buttons: NavigationButton[] | null }) => void
    clearNavigation: () => void
}

const TopNavigationContext = createContext<TopNavigationState>({
    links: null,
    buttons: null,
    setNavigation: () => {},
    clearNavigation: () => {},
})

export const TopNavigationProvider: FC = ({ children }) => {
    const [links, setLinks] = useState<NavigationLink[] | null>(null)
    const [buttons, setButtons] = useState<NavigationButton[] | null>(null)

    const setNavigation = useCallback((nav: { links: NavigationLink[] | null, buttons: NavigationButton[] | null }) => {
        setLinks(nav.links)
        setButtons(nav.buttons)
    }, [])

    const clearNavigation = useCallback(() => {
        setLinks(null)
        setButtons(null)
    }, [])

    return (
        <TopNavigationContext.Provider value={{ links, buttons, setNavigation, clearNavigation }}>
            {children}
        </TopNavigationContext.Provider>
    )
}

export const useTopNavigation = () => useContext(TopNavigationContext)
